<template>
<Page>
    <h1>Privacy Policy</h1>

    <p>This Privacy Policy describes how your personal information is collected, used, and shared when you visit coroot.com (the “Site”) or use the cloud-hosted application and infrastructure monitoring service, available through the Site (the “Service”).</p>

    <h2>PERSONAL INFORMATION WE COLLECT</h2>
    <p>
        When you visit the Site or the Service, we automatically collect certain information about your device,
        including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.
        Additionally, as you browse the Site or use the Service, we collect information about the individual web pages or products that you view,
        what websites or search terms referred you to the Site or the Service, and information about how you interact with the Site or the Service.
        We refer to this automatically-collected information as “Device Information.”
    </p>

    <p>We collect Device Information using the following technologies:</p>
    <ul>
        <li>“Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier.</li>
        <li>
            “Log files” track actions occurring on the Site, and collect data including your IP address, browser type,
            Internet service provider, referring/exit pages, and date/time stamps.</li>
        <li>
            “Web beacons”, “tags” and “pixels” are electronic files used to record information about how you browse the Site or use the Service.
        </li>
    </ul>

    <p>
        Additionally when you make a purchase or attempt to make a purchase through the Site or the Service,
        we collect certain information from you, including your name, billing address, shipping address,
        payment information (including credit card numbers), email address, and phone number.
        We refer to this information as “Order Information.”
    </p>

    <p>When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Order Information.</p>

    <h2>HOW DO WE USE YOUR PERSONAL INFORMATION?</h2>

    <p>We use the Order Information that we collect generally to fulfill any orders placed through the Site or the Service (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations). Additionally, we use this Order Information to:</p>
    <ul>
        <li>Communicate with you;</li>
        <li>Screen our orders for potential risk or fraud; and</li>
        <li>
            When in line with the preferences you have shared with us,
            provide you with information or advertising relating to our products or services.
        </li>
    </ul>

    <p>
        We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address),
        and more generally to improve and optimize the Site or the Service
        (for example, by generating analytics about how our customers browse and interact with the Site or the Service,
        and to assess the success of our marketing and advertising campaigns).
    </p>

    <h2>SHARING YOUR PERSONAL INFORMATION</h2>

    <p>
        We share your Personal Information with third parties to help us use your Personal Information, as described above.
    </p>

    <p>
        Third parties we currently use include:
    </p>

    <ul>
        <li>Stripe</li>
        <li>Sendgrid</li>
        <li>Intercom</li>
    </ul>

    <p>Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.</p>

    <h2>DO NOT TRACK</h2>

    <p>
        Some browsers have a “Do Not Track” feature that lets you tell websites that you do not want to have your online activities tracked.
        At this time, we do not respond to browser “Do Not Track” signals.
    </p>

    <h2>SECURITY</h2>

    <p>We take reasonable steps, including physical, technical and organizational measures, to protect your personal information from unauthorized access and against unlawful processing, accidental loss, destruction and damage. Unfortunately, transmission of information via the internet is not completely secure. Although we do our best to protect your personal information, we cannot guarantee the security of your personal information submitted to us.</p>

    <p>Your personal information will be retained by Coroot for the duration of your account and may be retained for a period after this time as necessary and relevant to our legitimate interests, the Terms, and in accordance with applicable legal obligations. This may include retention necessary to meet our tax reporting requirements as well as time required to enforce the relevant terms of agreement or to identify, issue or resolve legal proceedings. We may retain a record of your stated objection to the processing of your data, including in respect of an objection to receiving marketing communications, for the sole legitimate purpose of ensuring that we can continue to respect your wishes and not contact you further, during the term of your objection. When you place an order through the Site or the Service, we will maintain your Order Information for our records unless and until you ask us to delete this information.</p>

    <h2>YOUR RIGHTS</h2>

    <p>If you are a resident of the European Union, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.</p>

    <p>Additionally, if you are a resident of the European Union we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.</p>

    <h3>LAWFUL BASIS FOR PROCESSING YOUR INFORMATION</h3>

    <p>We are required to state the lawful basis under which we process the personal data of our end-users from the European Union. Accordingly, the lawful bases upon which we process your personal information are as follows:</p>
    <ul>
        <li>Where it is necessary to obtain your prior consent to the processing concerned in order for us to be allowed to do it, for instance in relation to direct marketing, we will obtain and rely on your consent in relation to the processing concerned;</li>
        <li>Otherwise, we will process your personal data only where the processing is necessary for compliance with a legal obligation to which we are a subject; or</li>
        <li>For the purposes of the legitimate interests pursued by us in promoting our business, providing the Service to our business customers pursuant to or legal agreements with them, and in ensuring the security, accessibility and improvement of our Site and the Service and the development of new technology and services.</li>
    </ul>

    <h3>TRANSFER OF INFORMATION TO THE U.S. AND OTHER COUNTRIES</h3>

    <p>Coroot is based in the United States. By accessing or using the Site or the Service, or otherwise providing information to us, you understand that your information will be subject to processing, transfer and storage in and to the U.S. where you may not have the same rights and protections as you do under local law. Please note that if you are a resident of the European Union, your information will be transferred outside of the European Union, to the United States of America and Canada.</p>

    <h3>EXTERNAL LINKS</h3>

    <p>
        The Site or the Service may, from time to time, contain links to external sites.
        If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any responsibility or liability for these policies.
        Please check these policies before you submit any personal data to these websites.
        We are not responsible for the privacy policies or the content of such sites.
    </p>

    <h2>MINORS</h2>

    <p>The Site is not intended for individuals under the age of 16.</p>

    <h2>CHANGES</h2>

    <p>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.</p>

    <h2>CONTACT US</h2>

    <p>For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at support@coroot.com or by mail at: Coroot Inc., 3790 El Camino Real #820, Palo Alto, CA 94306.</p>

</Page>
</template>

<script>
import Page from "@/pages/Page";

export default {
    components: {Page},
}
</script>

<style scoped>
h1 {
    text-align: center;
}
</style>
